import PocketBase from 'pocketbase';

const pb = new PocketBase('https://eihub.de/pb/');

// Disable auto cancellation for better performance
pb.autoCancellation(false);

/** Throws if the user is not authenticated. Call before any admin-only PocketBase request. */
export function requireAuth() {
    if (!pb.authStore.isValid) {
        throw new Error('User not authenticated');
    }
}

export default pb;